import React, { Component } from 'react';
import './../css/master.css';
import './../css/operationalDashboard.css';
import Header from './header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
//import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

var httpURL = '';
var sortVal = "";
var queryString = require('querystring');
var lstIpo = [];
var lstTransporter = [];
var ipoStatusList = [];
var lstOpDashboard = [];
var tempList = [];
var qtRequestCount = 0;
var qtSentCount = 0;
var qtAcceptCount = 0;
var poGenerationCount = 0;
var poAcceptCount = 0;
var deskloomCount = 0;
var dlActionCount = 0;
var dlRevisionCount = 0;
var dlApprovalCount = 0;
var ppCount = 0;
var ppActionCount = 0;
var ppRevisionCount = 0;
var ppApprovalCount = 0;
var planningCount = 0;
var completedPlanningCount = 0;
var csApprovalOnFinalCount = 0;
var wvrApprovalOnFinalCount = 0;
var wvrDispatchCount = 0;
var wvrWorkDoneCount = 0;
var finalWorkDoneCount = 0;
var finalDispatchCount = 0;
var invoiceCount = 0;

var filterQtRequest = false;
var filterQtResponse = false;
var filterQtAccepted = false;
var filterPoGenerated = false;
var filterPoAccepted = false;
var filterDlDt = false;
var filterDlAction = false;
var filterDlRevision = false;
var filterDlApproval = false;
var filterPpDt = false;
var filterPpAction = false;
var filterPpRevision = false;
var filterPpApproval = false;
var filterPlanning = false;
var filterCompletedPlanning = false;
var filterCsApprovalOnFinal = false;
var filterWvrApprovalOnFinal = false;
var filterWvrDispatch = false;
var filterWvrWorkDone = false;
var filterFinalWorkDone = false;
var filterFinalDispatch = false;
var filterInvoice = false;
//var glbIpoDesignId = localStorage.getItem("ipoDesignId");


class OperationalDashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			ipo: [],
			startDate: null,
			endDate: null,
			loader: 'none',
			opacity: 1,
			width: '98.6%',
			width1: '98.6%',
			ipoStatusList: [],
			width2: '98.6%',
			lstOpDashboard: [],
			glbIpoDesignId: localStorage.getItem("ipoDesignId"),
		}
	}
	setClicked1 = () => {
		this.resetAllFilters();
		filterQtRequest = !filterQtRequest;
		this.selectedProgress();
		this.setSummaryTable();

	}
	setClicked2 = () => {
		this.resetAllFilters();
		filterQtResponse = !filterQtResponse;
		this.selectedProgress();
		this.setSummaryTable();

	}

	setClicked3 = () => {
		this.resetAllFilters();
		filterQtAccepted = !filterQtAccepted;
		this.selectedProgress();
		this.setSummaryTable();
	}

	setClicked4 = () => {
		this.resetAllFilters();
		filterPoGenerated = !filterPoGenerated;
		this.selectedProgress();
		this.setSummaryTable();
	}

	setClicked5 = () => {
		this.resetAllFilters();
		filterPoAccepted = !filterPoAccepted;
		this.selectedProgress();
		this.setSummaryTable();
	}

	setClicked6 = () => {
		this.resetAllFilters();
		filterDlDt = !filterDlDt;
		this.selectedProgress();
		this.setSummaryTable();
	}

	setClicked7 = () => {
		this.resetAllFilters();
		filterDlAction = !filterDlAction;
		this.selectedProgress();
		this.setSummaryTable();

	}
	setClicked8 = () => {
		this.resetAllFilters();
		filterDlRevision = !filterDlRevision;
		this.selectedProgress();
		this.setSummaryTable();

	}
	setClicked9 = () => {
		this.resetAllFilters();
		filterDlApproval = !filterDlApproval;
		this.selectedProgress();
		this.setSummaryTable();

	}
	setClicked10 = () => {
		this.resetAllFilters();
		filterPpDt = !filterPpDt;
		this.selectedProgress();
		this.setSummaryTable();

	}
	setClicked11 = () => {
		this.resetAllFilters();
		filterPpAction = !filterPpAction;
		this.selectedProgress();
		this.setSummaryTable();

	}
	setClicked12 = () => {
		this.resetAllFilters();
		filterPpRevision = !filterPpRevision;
		this.selectedProgress();
		this.setSummaryTable();
	}
	setClicked13 = () => {
		this.resetAllFilters();
		filterPpApproval = !filterPpApproval;
		this.selectedProgress();
		this.setSummaryTable();

	}
	setClicked14 = () => {
		this.resetAllFilters();
		filterPlanning = !filterPlanning;
		this.selectedProgress();
		this.setSummaryTable();

	}
	setClicked15 = () => {
		this.resetAllFilters();
		filterCompletedPlanning = !filterCompletedPlanning;
		this.selectedProgress();
		this.setSummaryTable();

	}
	setClicked16 = () => {
		this.resetAllFilters();
		filterCsApprovalOnFinal = !filterCsApprovalOnFinal;
		this.selectedProgress();
		this.setSummaryTable();

	}
	setClicked17 = () => {
		this.resetAllFilters();
		filterWvrApprovalOnFinal = !filterWvrApprovalOnFinal;
		this.selectedProgress();
		this.setSummaryTable();

	}
	setClicked18 = () => {
		this.resetAllFilters();
		filterWvrDispatch = !filterWvrDispatch;
		this.selectedProgress();
		this.setSummaryTable();

	}
	setClicked19 = () => {
		this.resetAllFilters();
		filterWvrWorkDone = !filterWvrWorkDone;
		this.selectedProgress();
		this.setSummaryTable();

	}


	setClicked20 = () => {
		this.resetAllFilters();
		filterFinalWorkDone = !filterFinalWorkDone;
		this.selectedProgress();
		this.setSummaryTable();

	}
	setClicked21 = () => {
		this.resetAllFilters();
		filterFinalDispatch = !filterFinalDispatch;
		this.selectedProgress();
		this.setSummaryTable();

	}
	setClicked22 = () => {
		this.resetAllFilters();
		filterInvoice = !filterInvoice;
		this.selectedProgress();
		this.setSummaryTable();

	}
	resetAllFilters = () => {
		filterQtRequest = false;
		filterQtResponse = false;
		filterQtAccepted = false;
		filterPoGenerated = false;
		filterPoAccepted = false;
		filterDlDt = false;
		filterDlAction = false;
		filterDlRevision = false;
		filterDlApproval = false;
		filterPpDt = false;
		filterPpAction = false;
		filterPpRevision = false;
		filterPpApproval = false;
		filterPlanning = false;
		filterCompletedPlanning = false;
		filterCsApprovalOnFinal = false;
		filterWvrApprovalOnFinal = false;
		filterWvrDispatch = false;
		filterWvrWorkDone = false;
		filterFinalWorkDone = false;
		filterFinalDispatch = false;
		filterInvoice = false;
	}
	selectedProgress = () => {
		this.resetFilterImages();
		if (filterQtRequest) {
			$('#imgQtRequest').attr('src', '../img/1sel.png');
		}
		if (filterQtResponse) {
			$('#imgQtResponse').attr('src', '../img/2sel.png');
		}
		if (filterQtAccepted) {
			$('#imgQtAccept').attr('src', '../img/3sel.png');
		}
		if (filterPoGenerated) {
			$('#imgPoGenerated').attr('src', '../img/4sel.png');
		}
		if (filterPoAccepted) {
			$('#imgPoAccepted').attr('src', '../img/5sel.png');
		}
		if (filterDlDt) {
			$('#imgDlDt').attr('src', '../img/6sel.png');
		}
		if (filterDlAction) {
			$('#imgDlActioned').attr('src', '../img/7sel.png');
		}
		if (filterDlRevision) {
			$('#imgDlRevision').attr('src', '../img/8sel.png');
		}
		if (filterDlApproval) {
			$('#imgDlApproval').attr('src', '../img/9sel.png');
		}
		if (filterPpDt) {
			$('#imgPpDt').attr('src', '../img/10sel.png');
		}
		if (filterPpAction) {
			$('#imgPpActioned').attr('src', '../img/11sel.png');
		}
		if (filterPpRevision) {
			$('#imgPpRevision').attr('src', '../img/12sel.png');
		}
		if (filterPpApproval) {
			$('#imgPpApproval').attr('src', '../img/13sel.png');
		}
		if (filterPlanning) {
			$('#imgPlanDt').attr('src', '../img/14sel.png');
		}
		if (filterCompletedPlanning) {
			$('#imgFinalPlanDt').attr('src', '../img/15sel.png');
		}
		if (filterCsApprovalOnFinal) {
			$('#imgCsApprovalOnFinalDt').attr('src', '../img/16sel.png');
		}
		if (filterWvrApprovalOnFinal) {
			$('#imgWvrApprovalOnFinalDt').attr('src', '../img/17sel.png');
		}
		if (filterWvrDispatch) {
			$('#imgFiftyPctWvrDispatch').attr('src', '../img/18sel.png');
		}
		if (filterWvrWorkDone) {
			$('#imgWvrWorkdone').attr('src', '../img/19sel.png');
		}
		if (filterFinalWorkDone) {
			$('#imgCompletWorkdone').attr('src', '../img/20sel.png');
		}
		if (filterFinalDispatch) {
			$('#imgCompleteWvrDispatch').attr('src', '../img/21sel.png');
		}
		if (filterInvoice) {
			$('#imgInvSent').attr('src', '../img/22sel.png');
		}

	}
	resetFilterImages = () => {
		$('#imgQtRequest').attr('src', '../img/1.PNG');
		$('#imgQtResponse').attr('src', '../img/2.png');
		$('#imgQtAccept').attr('src', '../img/3.png');
		$('#imgPoGenerated').attr('src', '../img/4.png');
		$('#imgPoAccepted').attr('src', '../img/5.png');
		$('#imgDlDt').attr('src', '../img/6.png');
		$('#imgDlActioned').attr('src', '../img/7.png');
		$('#imgDlRevision').attr('src', '../img/8.png');
		$('#imgDlApproval').attr('src', '../img/9.png');
		$('#imgPpDt').attr('src', '../img/10.png');
		$('#imgPpActioned').attr('src', '../img/11.png');
		$('#imgPpRevision').attr('src', '../img/12.png');
		$('#imgPpApproval').attr('src', '../img/13.png');
		$('#imgPlanDt').attr('src', '../img/14.png');
		$('#imgFinalPlanDt').attr('src', '../img/15.png');
		$('#imgCsApprovalOnFinalDt').attr('src', '../img/16.png');
		$('#imgWvrApprovalOnFinalDt').attr('src', '../img/17.png');
		$('#imgFiftyPctWvrDispatch').attr('src', '../img/18.png');
		$('#imgWvrWorkdone').attr('src', '../img/19.png');
		$('#imgCompletWorkdone').attr('src', '../img/20.png');
		$('#imgCompleteWvrDispatch').attr('src', '../img/21.png');
		$('#imgInvSent').attr('src', '../img/22.png');
	}

	async componentDidMount() {

		this.handleResize();
		window.addEventListener("load", this.handleResize);
		window.addEventListener("resize", this.handleResize);

		var startDate = new Date();
		var startDate = startDate.setDate(startDate.getDate() - 60);
		await this.setState({
			startDate: new Date(startDate),
		});
		var endDate = new Date();
		var endDate = endDate.setDate(endDate.getDate() + 60);
		await this.setState({
			endDate: new Date(endDate),
		});
		// $('#filterStatusCmb').prepend($("<option> </option>").val(0).html('Status'));
		this.getSummmary();
		// lstOpDashboard = this.state.lstOpDashboard;

		// this.setSummaryTable();
	}

	handleResize = () => {
		var width = ($('.tableLayout1').parent().width()) - 18;
		var width1 = ($('.tableLayout2').parent().width()) - 18;
		var width2 = ($('.tableLayout3').parent().width()) - 18;
		this.setState({ width: width, width1: width1, width2: width2 });
	}

	getSummmary = () => {
		var fromDt = $('#inp_fromDate').val();
		var toDt = $('#inp_toDate').val();
		if (Date.parse(this.state.startDate) > Date.parse(this.state.endDate)) {
			toast.warning('End Date should be greater than Start Date');
			return false;
		}
		this.setState({ loader: 'block', opacity: 0.5 });
		axiosInstance.post(httpURL + '/a/report/op_dashboard/list',
			queryString.stringify({ 'fromDt': fromDt, 'toDt': toDt }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				this.setState({
					lstOpDashboard: response.data.lstOpDashboard,

				})

				lstOpDashboard = this.state.lstOpDashboard;

				this.setSummaryTable();
				// this.fillStatusCmb();
				// this.getAllIpo();
			}
			else {
				toast.error(response.data.SvcMsg);
				if (response.data.SvcMsg == 'You are not logged in') {
					window.location.href = window.CSURL;
					return false;
				} else {
					$('#dashboardTableBody tr').remove();
				}
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((error) => {
			toast.error("Service failed " + error);
		});
	}

	setSummaryTable = () => {
		$('#dashboardTableBody tr').remove();
		var table = document.getElementById('dashboardTable');
		var tbody = document.getElementById('dashboardTableBody');
		var filterIpoNo = $('#filterIpoNo').val().trim().toLowerCase();
		var filterWeaver = $('#filterWeaver').val().trim().toLowerCase();
		var filterBpoNo = $('#filterBpoNo').val().trim().toLowerCase();
		var filterDesignColor = $('#filterDesignColor').val().trim().toLowerCase();


		// if (filterIpoNo.length != 0 || filterWeaver.length != 0) {
		var operationalDbLst = this.state.lstOpDashboard;
		for (var i = 0; i < operationalDbLst.length; i++) {
			// var quoteId = operationalDbLst[i].quoteId;
			var ipoId = operationalDbLst[i].ipoId;
			var ipoNo = operationalDbLst[i].ipoNo;
			ipoNo = ipoNo == null || ipoNo == '' ? '-' : ipoNo;

			var buyerPOId = operationalDbLst[i].bpoId;
			var weaverId = operationalDbLst[i].wvrId;
			var weaver = operationalDbLst[i].wvr;
			weaver = weaver == null || weaver == '' ? '-' : weaver;
			var ipoLength = operationalDbLst[i].ipoLength;
			var bpoId = operationalDbLst[i].bpoId;
			var bpoNo = operationalDbLst[i].bpoNo;
			var pCompanyId = operationalDbLst[i].pCompanyId;
			var pCompany = operationalDbLst[i].pCompany;
			var buyerDelDt = operationalDbLst[i].buyerDelDt;
			buyerDelDt = buyerDelDt == null || buyerDelDt == '' ? '-' : buyerDelDt;
			var wvrDelDt = operationalDbLst[i].wvrDelDt;
			wvrDelDt = wvrDelDt == null || wvrDelDt == '' ? '-' : wvrDelDt;
			var styleId = operationalDbLst[i].styleId;
			var style = operationalDbLst[i].style;
			var color = operationalDbLst[i].color;
			var designId = operationalDbLst[i].designId;
			var designNoColor = operationalDbLst[i].designNoColor;
			designNoColor = designNoColor == null || designNoColor == '' ? '-' : designNoColor;
			//var width = operationalDbLst[i].width;
			//var bufferDays = operationalDbLst[i].bufferDays;
			//var construction = operationalDbLst[i].construction;
			// var yarnCount = operationalDbLst[i].yarnCount;
			// var qualityId = operationalDbLst[i].qualityId;
			// var quality = operationalDbLst[i].quality;
			var ipoDesignId = operationalDbLst[i].ipoDesignId;
			// var buyerLength = operationalDbLst[i].buyerLength;
			var dtQtRequest = operationalDbLst[i].summary.dtQtRequest;
			dtQtRequest = dtQtRequest == '' || dtQtRequest == null ? '-' : dtQtRequest;
			var dtQtResponse = operationalDbLst[i].summary.dtQtResponse;
			dtQtResponse = dtQtResponse == '' || dtQtResponse == null ? '-' : dtQtResponse;
			var dtQtApproval = operationalDbLst[i].summary.dtQtApproval;
			dtQtApproval = dtQtApproval == '' || dtQtApproval == null ? '-' : dtQtApproval;
			var dtIpoGeneration = operationalDbLst[i].summary.dtIpoGeneration;
			dtIpoGeneration = dtIpoGeneration == '' || dtIpoGeneration == null ? '-' : dtIpoGeneration;
			var dtIpoApproval = operationalDbLst[i].summary.dtIpoApproval;
			dtIpoApproval = dtIpoApproval == '' || dtIpoApproval == null ? '-' : dtIpoApproval;
			var dtDl = operationalDbLst[i].summary.dtDl;
			dtDl = dtDl == '' || dtDl == null ? '-' : dtDl;
			var dtDlActioned = operationalDbLst[i].summary.dtDlActioned;
			dtDlActioned = dtDlActioned == '' || dtDlActioned == null ? '-' : dtDlActioned;
			var dtDlRevision = operationalDbLst[i].summary.dtDlRevision;
			dtDlRevision = dtDlRevision == '' || dtDlRevision == null ? '-' : dtDlRevision;
			var dtDlApproval = operationalDbLst[i].summary.dtDlApproval;
			dtDlApproval = dtDlApproval == '' || dtDlApproval == null ? '-' : dtDlApproval;
			var dtPp = operationalDbLst[i].summary.dtPp;
			dtPp = dtPp == '' || dtPp == null ? '-' : dtPp;
			var dtPpActioned = operationalDbLst[i].summary.dtPpActioned;
			dtPpActioned = dtPpActioned == '' || dtPpActioned == null ? '-' : dtPpActioned;
			var dtPpRevision = operationalDbLst[i].summary.dtPpRevision;
			dtPpRevision = dtPpRevision == '' || dtPpRevision == null ? '-' : dtPpRevision;
			var dtPpApproval = operationalDbLst[i].summary.dtPpApproval;
			dtPpApproval = dtPpApproval == '' || dtPpApproval == null ? '-' : dtPpApproval;
			var dtPlan = operationalDbLst[i].summary.dtPlan;
			dtPlan = dtPlan == '' || dtPlan == null ? '-' : dtPlan;
			var dtPlanCompletion = operationalDbLst[i].summary.dtPlanCompletion;
			dtPlanCompletion = dtPlanCompletion == '' || dtPlanCompletion == null ? '-' : dtPlanCompletion;
			var dtCsApprovedFinal = operationalDbLst[i].summary.dtCsApprovedFinal;
			dtCsApprovedFinal = dtCsApprovedFinal == '' || dtCsApprovedFinal == null ? '-' : dtCsApprovedFinal;
			var dtWvrApprovedFinal = operationalDbLst[i].summary.dtWvrApprovedFinal;
			dtWvrApprovedFinal = dtWvrApprovedFinal == '' || dtWvrApprovedFinal == null ? '-' : dtWvrApprovedFinal;
			var dtFiftyPctWvrDispatch = operationalDbLst[i].summary.dtFiftyPctWvrDispatch;
			dtFiftyPctWvrDispatch = dtFiftyPctWvrDispatch == '' || dtFiftyPctWvrDispatch == null ? '-' : dtFiftyPctWvrDispatch;
			var dtWvrWorkDone = operationalDbLst[i].summary.dtWvrWorkDone;
			dtWvrWorkDone = dtWvrWorkDone == '' || dtWvrWorkDone == null ? '-' : dtWvrWorkDone;
			var dtFinalWorkDone = operationalDbLst[i].summary.dtFinalWorkDone;
			dtFinalWorkDone = dtFinalWorkDone == '' || dtFinalWorkDone == null ? '-' : dtFinalWorkDone;
			var dtDispatchCompletion = operationalDbLst[i].summary.dtDispatchCompletion;
			dtDispatchCompletion = dtDispatchCompletion == '' || dtDispatchCompletion == null ? '-' : dtDispatchCompletion;
			var dtInvoice = operationalDbLst[i].summary.dtInvoice;
			dtInvoice = dtInvoice == '' || dtInvoice == null ? '-' : dtInvoice;


			var flgQtRequest = operationalDbLst[i].summary.flgQtRequest;
			var flgQtResponse = operationalDbLst[i].summary.flgQtResponse;
			var flgQtApproved = operationalDbLst[i].summary.flgQtApproved;
			var flgIpoGenerated = operationalDbLst[i].summary.flgIpoGenerated;
			var flgIpoAccepted = operationalDbLst[i].summary.flgIpoAccepted;
			var flgWvrDlShared = operationalDbLst[i].summary.flgWvrDlShared;
			var flgDlActioned = operationalDbLst[i].summary.flgDlActioned;
			var flgDlRevised = operationalDbLst[i].summary.flgDlRevised;
			var flgDlApproved = operationalDbLst[i].summary.flgDlApproved;
			var flgPpShared = operationalDbLst[i].summary.flgPpShared;
			var flgPpActioned = operationalDbLst[i].summary.flgPpActioned;
			var flgPpRevised = operationalDbLst[i].summary.flgPpRevised;
			var flgPpApproved = operationalDbLst[i].summary.flgPpApproved;
			var flgPlanShared = operationalDbLst[i].summary.flgPlanShared;
			var flgPlanCompleted = operationalDbLst[i].summary.flgPlanCompleted;
			var flgFinalPlanApproved = operationalDbLst[i].summary.flgFinalPlanApproved;
			// var flgWvrApprovalOnFinal	= operationalDbLst[i].summary.flgWvrApprovalOnFinal;
			var flgFiftyPctDispatched = operationalDbLst[i].summary.flgFiftyPctDispatched;
			var flgWvrWorkDone = operationalDbLst[i].summary.flgWvrWorkDone;
			var flgFinalWorkDone = operationalDbLst[i].summary.flgFinalWorkDone;
			var flgDispatchCompleted = operationalDbLst[i].summary.flgDispatchCompleted;
			var flgInvoiceSent = operationalDbLst[i].summary.flgInvoiceSent;

			if (flgQtRequest) qtRequestCount++;
			if (flgQtResponse) qtSentCount++;
			if (flgQtApproved) qtAcceptCount++;
			if (flgIpoGenerated) poGenerationCount++;
			if (flgIpoAccepted) poAcceptCount++;
			if (flgWvrDlShared) deskloomCount++;
			if (flgDlActioned) dlActionCount++;
			if (flgDlRevised) dlRevisionCount++;
			if (flgDlApproved) dlApprovalCount++;
			if (flgPpShared) ppCount++;
			if (flgPpActioned) ppActionCount++;
			if (flgPpRevised) ppRevisionCount++;
			if (flgPpApproved) ppApprovalCount++;
			if (flgPlanShared) planningCount++;
			if (flgPlanCompleted) completedPlanningCount++;
			if (flgFinalPlanApproved) csApprovalOnFinalCount++;
			// if (flgWvrApprovalOnFinal)	wvrApprovalOnFinalCount++;
			if (flgFiftyPctDispatched) wvrDispatchCount++;
			if (flgWvrWorkDone) wvrWorkDoneCount++;
			if (flgFinalWorkDone) finalWorkDoneCount++;
			if (flgDispatchCompleted) finalDispatchCount++;
			if (flgInvoiceSent) invoiceCount++;
			var row = document.createElement('tr');
			row.id = 'ipoDesignId' + ipoDesignId;

			if (filterIpoNo.length != 0 && ipoNo.toLowerCase().indexOf(filterIpoNo) === -1)
				continue;
			if (filterWeaver.length != 0 && weaver.toLowerCase().indexOf(filterWeaver) === -1)
				continue;
			if (filterBpoNo.length != 0 && bpoNo.toLowerCase().indexOf(filterBpoNo) === -1)
				continue;
			if (filterDesignColor.length != 0 && designNoColor.toLowerCase().indexOf(filterDesignColor) === -1)
				continue;

			if (filterQtRequest && !flgQtRequest) continue;
			if (filterQtResponse && !flgQtResponse) continue;
			if (filterQtAccepted && !flgQtApproved) continue;
			if (filterPoGenerated && !flgIpoGenerated) continue;
			if (filterPoAccepted && !flgIpoAccepted) continue;
			if (filterDlDt && !flgWvrDlShared) continue;
			if (filterDlAction && !flgDlActioned) continue;
			if (filterDlRevision && !flgDlRevised) continue;
			if (filterDlApproval && !flgDlApproved) continue;
			if (filterPpDt && !flgPpShared) continue;
			if (filterPpAction && !flgPpActioned) continue;
			if (filterPpRevision && !flgPpRevised) continue;
			if (filterPpApproval && !flgPpApproved) continue;
			if (filterPlanning && !flgPlanShared) continue;
			if (filterCompletedPlanning && !flgPlanCompleted) continue;
			if (filterCsApprovalOnFinal && !flgFinalPlanApproved) continue;
			// if (filterWvrApprovalOnFinal 		&& !flgWvrApprovalOnFinal) continue;
			if (filterWvrDispatch && !flgFiftyPctDispatched) continue;
			if (filterWvrWorkDone && !flgWvrWorkDone) continue;
			if (filterFinalWorkDone && !flgFinalWorkDone) continue;
			if (filterFinalDispatch && !flgDispatchCompleted) continue;
			if (filterInvoice && !flgInvoiceSent) continue;

			//var pipe = length + " | " + width + " | " + construction;


			this.addTD(row, ipoId, 'no-display');
			this.addTD(row, ipoNo, '');
			this.addTD(row, pCompanyId, 'no-display');
			this.addTD(row, pCompany, '');
			this.addTD(row, weaverId, 'no-display');
			this.addTD(row, weaver, '');
			this.addTD(row, designId, 'no-display');
			this.addTD(row, designNoColor, '');

			this.addTD(row, style, '');
			this.addTD(row, color, '');
			this.addTD(row, bpoId, 'no-display');
			this.addTD(row, bpoNo, '');
			this.addTD(row, buyerDelDt, 'text-center');
			this.addTD(row, wvrDelDt, 'text-center');
			// this.addTD(row, ipoDesignId, 'no-display');
			this.addTDEdit(row, 'glyphicon glyphicon-option-vertical', 'text-center');
			var cell = document.createElement('td');
			cell.style.width = '300px';
			// cell.setAttribute('ddcopyrecvdt',pDdCopyReceiveDt);
			cell.title = 'Quote Request Date : ' + dtQtRequest + '\u000a'
				+ 'Quote Sent Date : ' + dtQtResponse + '\u000a'
				+ 'Quote Accept Date : ' + dtQtApproval + '\u000a'
				+ 'IPO Generation Date : ' + dtIpoGeneration + '\u000a'
				+ 'IPO Accept Date : ' + dtIpoApproval + '\u000a'
				+ 'Deskloom Date : ' + dtDl + '\u000a'
				+ 'Deskloom Action Date : ' + dtDlActioned + '\u000a'
				+ 'Deskloom Revision Date : ' + dtDlRevision + '\u000a'
				+ 'Deskloom Approval Date : ' + dtDlApproval + '\u000a'
				+ 'PP Yardage Date : ' + dtPp + '\u000a'
				+ 'PP Y/D Action Date : ' + dtPpActioned + '\u000a'
				+ 'PP Y/D Revision Date : ' + dtPpRevision + '\u000a'
				+ 'PP Y/D Approval Date : ' + dtPpApproval + '\u000a'
				+ 'Planning Date : ' + dtPlan + '\u000a'
				+ 'Complete Planning Date : ' + dtPlanCompletion + '\u000a'
				+ 'Approval On Final Date : ' + dtWvrApprovedFinal + '\u000a'
				// + 'Weaver Approval On Final Date : '+ dtWvrApprovedFinal + '\u000a' 	
				+ 'Weaver Dispatch Date : ' + dtFiftyPctWvrDispatch + '\u000a'
				+ 'Weaver WorkDone Date : ' + dtWvrWorkDone + '\u000a'
				+ 'Final WorkDone Date : ' + dtFinalWorkDone + '\u000a'
				+ 'Final Dispatch Date : ' + dtDispatchCompletion + '\u000a'
				+ 'Invoice Date : ' + dtInvoice;

			this.createProgressQuoteRequest(row, cell, flgQtRequest, 'Quote Request Date');
			this.createProgressQuoteRequest(row, cell, flgQtResponse, 'Quote Response Date');
			this.createProgressQuoteRequest(row, cell, flgQtApproved, 'Quote Accept Date');
			this.createProgressQuoteRequest(row, cell, flgIpoGenerated, 'PO Generation Date');
			this.createProgressQuoteRequest(row, cell, flgIpoAccepted, 'PO Accept Date');
			this.createProgressQuoteRequest(row, cell, flgWvrDlShared, 'Deskloom Date');
			this.createProgressQuoteRequest(row, cell, flgDlActioned, 'Deskloom Action Date');
			this.createProgressQuoteRequest(row, cell, flgDlRevised, 'Deskloom Revision Date');
			this.createProgressQuoteRequest(row, cell, flgDlApproved, 'Deskloom Approval Date');
			this.createProgressQuoteRequest(row, cell, flgPpShared, 'PP Yardage Date');
			this.createProgressQuoteRequest(row, cell, flgPpActioned, 'PP Y/D Action Date');
			this.createProgressQuoteRequest(row, cell, flgPpRevised, 'PP Y/D Revision Date');
			this.createProgressQuoteRequest(row, cell, flgPpApproved, 'PP Y/D Approval Date');
			this.createProgressQuoteRequest(row, cell, flgPlanShared, 'Planning Date');
			this.createProgressQuoteRequest(row, cell, flgPlanCompleted, 'Complete Planning Date');
			this.createProgressQuoteRequest(row, cell, flgFinalPlanApproved, 'Approval On Final Date');
			// this.createProgressQuoteRequest(row,cell,flgWvrApprovalOnFinal,'Weaver Approval On Final Date');
			this.createProgressQuoteRequest(row, cell, flgFiftyPctDispatched, 'Weaver Dispatch Date');
			this.createProgressQuoteRequest(row, cell, flgWvrWorkDone, 'Weaver WorkDone Date');
			this.createProgressQuoteRequest(row, cell, flgFinalWorkDone, 'Final WorkDone Date');
			this.createProgressQuoteRequest(row, cell, flgDispatchCompleted, 'Final Dispatch Date');
			this.createProgressQuoteRequest(row, cell, flgInvoiceSent, 'Invoice Date');
			tbody.append(row);
		}
		// }

		table.append(tbody);
		this.setState({
			glbIpoDesignId: '',
		})
	}


	addTD(row, val, classname) {
		var cell = document.createElement('td');
		cell.className = classname;
		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);
	}
	addTDEdit(row, val, classname) {
		var cell = document.createElement('td');
		var span = document.createElement('span');
		cell.className = classname;
		span.className = val;
		span.style.position = 'relative';
		span.style.cursor = 'pointer';
		cell.append(span);
		row.append(cell);
	}
	createProgressQuoteRequest(row, cell, pFlgProgress, pTitle) {
		var wrapperDivElement = document.createElement('div');
		wrapperDivElement.className = 'statusIconGroup';
		var divElement = document.createElement('div');
		var imgElement = document.createElement('img');
		if (pFlgProgress == 2) {
			$(imgElement).attr("src", "../img/green_arrow.png");
			$(imgElement).attr("height", "20px");
		} else
			if (pFlgProgress == 3) {
				$(imgElement).attr("src", "../img/red_arrow1.png");
				$(imgElement).attr("height", "20px");
			} else
				if (pFlgProgress == 4) {
					$(imgElement).attr("src", "../img/red_arrow2.png");
					$(imgElement).attr("height", "20px");
				} else {//vehicleProgress < QUOTE_RECEIVED
					$(imgElement).attr("src", "../img/arrow_gray.png");
					$(imgElement).attr("height", "20px");
				}
		divElement.title = pTitle;
		divElement.className = 'statusIcon';
		divElement.appendChild(imgElement);
		wrapperDivElement.appendChild(divElement);
		cell.appendChild(wrapperDivElement);
		row.appendChild(cell);
	}
	highlightRow(table, id) {
		$('#' + table + ' tr').each(function () {
			var designId = $(this).find('td:eq(0)').text();
			if (designId == id) {
				$(this).addClass('selected').siblings().removeClass('selected');
			}
		});
	}


	sortAscByCreated = () => {
		if (sortVal != 'ascre') {
			sortVal = 'ascre';
			$("#createdAsDtIcon").css("color", "gray");
			$("#createdDsDtIcon").css("color", "#111");

			var val1;
			var val2;

			for (var i = 0; i < lstIpo.length - 1; i++) {
				val1 = lstIpo[i].createdOn;
				for (var j = i + 1; j < lstIpo.length; j++) {
					val2 = lstIpo[j].createdOn;
					if (val1 > val2) {
						var tmp = lstIpo[j];
						lstIpo[j] = lstIpo[i];
						lstIpo[i] = tmp;
						val1 = lstIpo[i].createdOn;
					}
				}
			}
			this.setSummaryTable();
		}
	}

	sortDesByCreated = () => {
		if (sortVal != 'dscre') {
			sortVal = 'dscre';
			$("#createdAsDtIcon").css("color", "#111");
			$("#createdDsDtIcon").css("color", "gray");

			var val1;
			var val2;

			for (var i = 0; i < lstIpo.length - 1; i++) {
				val1 = lstIpo[i].createdOn;
				for (var j = i + 1; j < lstIpo.length; j++) {
					val2 = lstIpo[j].createdOn;
					if (val1 < val2) {
						var tmp = lstIpo[j];
						lstIpo[j] = lstIpo[i];
						lstIpo[i] = tmp;
						val1 = lstIpo[i].createdOn;
					}
				}
			}
			this.setSummaryTable();
		}
	}


	render() {
		httpURL = window.httpURL;
		return (
			<div style={{ height: '100%' }}>
				<Header />
				<ToastContainer autoClose={2000} hideProgressBar />
				<div style={{ position: 'fixed', width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: this.state.loader }}>
					<img src={require("../images/loader.gif")} alt="Loader..." />
				</div>
				<div className="main" style={{ opacity: this.state.opacity }}>
					<div className="container-fluid">
						<div className="col-sm-12 col-centered padding-remove">
							<div className="col-sm-12 padding-remove" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
								<label htmlFor="inp_fromDate">From Date</label>
								<div style={{ marginLeft: 5, width: 100 }}>
									<DatePicker id="inp_fromDate"
										className='form-control text-center'
										placeholderText="From Date"
										selected={this.state.startDate}
										dateFormat="dd-MM-yyyy"
										autoComplete='off'
										onChange={(date) => { this.setState({ startDate: date }) }}
									/>
								</div>
								<label style={{ marginLeft: 10 }} htmlFor="inp_toDate">To Date</label>
								<div style={{ marginLeft: 5, width: 100 }}>
									<DatePicker id="inp_toDate"
										className='form-control text-center'
										placeholderText="To Date"
										selected={this.state.endDate}
										dateFormat="dd-MM-yyyy"
										autoComplete='off'
										onChange={(date) => { this.setState({ endDate: date }) }}
									/>
								</div>
								<button style={{ marginLeft: 20 }} type="button" id="getData" className="btn btn-warning" onClick={this.getSummmary}>Get Data</button>

							</div>
							<div className="col-sm-12 padding-remove">
								<table className="tableLayout1" style={{ width: this.state.width }}>
									<thead>
										<tr>
											<th style={{ width: 30, display: "none" }}>Quote Id</th>
											<th style={{ width: 30, display: 'none' }}>Ipo Id</th>
											<th style={{ width: 22 }}>
												<input type="text" onChange={this.setSummaryTable} className="form-control inp-search" id="filterIpoNo" placeholder="Ipo No" />
											</th>
											<th style={{ width: 50, display: 'none' }}>Company Id</th>
											<th style={{ width: 40 }}>Parent Company</th>
											<th style={{ width: 30, display: 'none' }}>Weaver Id</th>
											<th style={{ width: 25 }}>
												<input type="text" onChange={this.setSummaryTable} className="form-control inp-search" id="filterWeaver" placeholder="Weaver" />
											</th>
											<th style={{ width: 50, display: 'none' }}>Design Id</th>
											<th style={{ width: 40 }}>
												<input type="text" onChange={this.setSummaryTable} className="form-control inp-search" id="filterDesignColor" placeholder="Design Color" />
											</th>
											<th style={{ width: 50, display: 'none' }}>Style Id</th>
											<th style={{ width: 25 }}>Style</th>
											<th style={{ width: 25 }}>Color</th>

											<th style={{ width: 50, display: 'none' }}>BPO Id</th>
											<th style={{ width: 40 }}>
												<input type="text" onChange={this.setSummaryTable} className="form-control inp-search" id="filterBpoNo" placeholder="Bpo No." />
											</th>
											<th style={{ width: 25 }}>Buyer Del. Dt.</th>
											<th style={{ width: 25 }}>Wvr. Del. Dt.</th>
											<th style={{ width: 25 }}>Action</th>
											<th style={{ width: 270 }}>
												<div style={{ height: '50%' }}>PO Progress</div>
												<div style={{ height: '50%' }}>
													<div className="col-sm-12 padding-remove">
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgQtRequest" onClick={this.setClicked1} src={require("../images/1.png")} title="Quote Request Sent" style={{ width: '20' }} />
															</div>
														</div>
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgQtResponse" onClick={this.setClicked2} src={require("../images/2.png")} title="Quote Response" style={{ width: '20' }} />
															</div>
														</div>
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgQtAccept" onClick={this.setClicked3} src={require("../images/3.png")} title="Quote Accepted" style={{ width: '20' }} />
															</div>
														</div>
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgPoGenerated" onClick={this.setClicked4} src={require("../images/4.png")} title="IPO Generated" style={{ width: '20' }} />
															</div>
														</div>
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgPoAccepted" onClick={this.setClicked5} src={require("../images/5.png")} title="IPO Accepted" style={{ width: '20' }} />
															</div>
														</div>
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgDlDt" onClick={this.setClicked6} src={require("../images/6.png")} title="Deskloom Date" style={{ width: '20' }} />
															</div>
														</div>
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgDlActioned" onClick={this.setClicked7} src={require("../images/7.png")} title="Deskloom Actioned" style={{ width: '20' }} />
															</div>
														</div>
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgDlRevision" onClick={this.setClicked8} src={require("../images/8.png")} title="Deskloom Revised Date" style={{ width: '20' }} />
															</div>
														</div>
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgDlApproval" onClick={this.setClicked9} src={require("../images/9.png")} title="Deskloom Approval" style={{ width: '20' }} />
															</div>
														</div>
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgPpDt" onClick={this.setClicked10} src={require("../images/10.png")} title="PP Yardage Date" style={{ width: '20' }} />
															</div>
														</div>
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgPpActioned" onClick={this.setClicked11} src={require("../images/11.png")} title="PP Yardage Actioned" style={{ width: '20' }} />
															</div>
														</div>
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgPpRevision" onClick={this.setClicked12} src={require("../images/12.png")} title="PP Yardage Revised Date" style={{ width: '20' }} />
															</div>
														</div>
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgPpApproval" onClick={this.setClicked13} src={require("../images/13.png")} title="PP Yardage Approval" style={{ width: '20' }} />
															</div>
														</div>
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgPlanDt" onClick={this.setClicked14} src={require("../images/14.png")} title="Planning Date" style={{ width: '20' }} />
															</div>
														</div>
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgFinalPlanDt" onClick={this.setClicked15} src={require("../images/15.png")} title="100% Planning Date" style={{ width: '20' }} />
															</div>
														</div>
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgCsApprovalOnFinalDt" onClick={this.setClicked16} src={require("../images/16.png")} title="Approval on Final Date" style={{ width: '20' }} />
															</div>
														</div>
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgFiftyPctWvrDispatch" onClick={this.setClicked18} src={require("../images/18.png")} title="50% Weaver Dispatch" style={{ width: '20' }} />
															</div>
														</div>
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgWvrWorkdone" onClick={this.setClicked19} src={require("../images/19.png")} title="Workdone by Weaver" style={{ width: '20' }} />
															</div>
														</div>
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgCompletWorkdone" onClick={this.setClicked20} src={require("../images/20.png")} title="Final Workdone Date" style={{ width: '20' }} />
															</div>
														</div>
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgCompleteWvrDispatch" onClick={this.setClicked21} src={require("../images/21.png")} title="Complete Dispatch" style={{ width: '20' }} />
															</div>
														</div>
														<div className="statusIconGroup">
															<div className="statusIcon">
																<img height="25" id="imgInvSent" onClick={this.setClicked22} src={require("../images/22.png")} title="Invoice Sent" style={{ width: '20' }} />
															</div>
														</div>
													</div>
												</div>
											</th>
										</tr>
									</thead>
								</table>
								<div className="col-sm-12 dashboardTableDiv padding-remove">
									<table id="dashboardTable" className="tableLayout">
										<colgroup>
											<col width="22" />
											<col width="40" />
											<col width="25" />
											<col width="40" />
											<col width="25 " />
											<col width="25" />
											<col width="40" />
											<col width="25" />
											<col width="25 " />
											<col width="25" />

											<col width="270" />
										</colgroup>
										<tbody id="dashboardTableBody"></tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default OperationalDashboard;
